import React, { Fragment, ReactNode, useMemo, useState } from "react";
import { ContentTabsTop } from "../ChatListLayout/ContentTabsTop";
import { Avatar, Button, List, Tag } from "antd";
import "./index.less";
import { useTranslate } from "@obsbot/remo-i18n";
import { useFriendStore } from "@obsbot/remo-stores";
import { ListEmpty } from "../ChatListLayout/ContactList/ListEmpty";
import { IntimateItems } from "@obsbot/remo-services";
import { handleIntimate, revokeIntimate } from "@obsbot/remo-server-api";
import { getRelationType } from "../ChatListLayout/ContactList";
import { RelationshipIcon, UndoIcon } from "../SvgIconCom/ChatContentIcon";
// import { UndoOutlined } from "@ant-design/icons";
import { formatShowTime } from "../../utils/util";
import { eventBus } from "@obsbot/remo-utils";

interface RelationProps {
    show: boolean;
}

export const RelationShipTodo: React.FC<RelationProps> = ({ show }) => {
    const t = useTranslate();
    const { intimate, rtm } = useFriendStore();
    const [currentTab, setCurrentTab] = useState<string>(() => {
        if (intimate.sendList.length > 0 && intimate.receiveList.length === 0) {
            return "relationship-out";
        } else {
            return "relationship-in";
        }
    });

    const changeTab = (key: string): void => {
        setCurrentTab(key);
    };

    // 撤回亲密请求
    const handleRevoke = async (item: IntimateItems): Promise<void> => {
        await revokeIntimate(item.id);
    };

    const handleInvited = async (status: string, item: IntimateItems): Promise<void> => {
        const { from, to, id, relationship, msgId } = item;
        let res;
        try {
            // 判断是确认添加还是确认变更
            res = await handleIntimate({
                userId: to.userID,
                friendId: from.userID,
                relationType: getRelationType(relationship),
                flag: status === "accept" ? 1 : 0, // 0-拒绝 1-同意
                intimateRequestId: id,
            });
        } catch (error) {
            res = error;
        }
        const tempID = currentTab === "relationship-in" ? from.userID : to.userID;
        // 查找要修改的消息体
        const msg: any = await getMessageList("", msgId, "C2C" + tempID);
        if (res.code === "200" && msg?.payload) {
            const tempExtension = JSON.parse(msg.payload.extension);
            msg.payload.extension = JSON.stringify({
                ...tempExtension,
                status: status,
                time: formatShowTime(new Date().valueOf()),
            });
            eventBus.emit("show-message", {
                message: t("relationship.status-" + status),
                type: "success",
            });
            // 修改自定义消息内容
            rtm?.handleRelationShipMsg(msg);
        } else if ((res.code === "RM.10032" || res.code === "RM.10036") && msg?.payload) {
            const tempExtension = JSON.parse(msg.payload.extension);
            msg.payload.extension = JSON.stringify({
                ...tempExtension,
                status: "expire",
                time: formatShowTime(new Date().valueOf()),
            });
            // 修改自定义消息内容
            rtm?.handleRelationShipMsg(msg);
        }
    };

    const getMessageList = async (
        nextReqMessageID?: string,
        targetMessageID?: string, // Add the message ID you're looking for
        conversationID?: string,
    ): Promise<void> => {
        if (rtm && conversationID) {
            // Step 1: Fetch the next page of messages
            const res = await rtm.getMessageList(conversationID, nextReqMessageID);
            // Use a temporary variable for the message list
            const tempResMsg = [...res.messageList];
            // Step 2: Search for the targetMessageID in the filtered list
            const foundMessage = tempResMsg.find(message => message.ID === targetMessageID);
            // Step 3: Check for the base case (message found or no more pages)
            if (foundMessage) {
                console.log("Message found:", foundMessage);
                return foundMessage; // Found the message, stop recursion
            } else if (res.isCompleted) {
                console.log("Message not found. Reached end of history.");
                return; // Reached the end, stop recursion
            }
            // Step 4: If the message wasn't found and there are more pages, recurse
            if (res.nextReqMessageID) {
                console.log("Message not found on this page. Fetching next page...");
                // Recursively call the function with the new nextReqMessageID
                getMessageList(res.nextReqMessageID, targetMessageID, conversationID);
            } else {
                console.log("No more pages to fetch.");
            }
        }
    };

    const tabItems = useMemo(() => {
        const items = [
            {
                key: "relationship-in",
                label: t("chat.apply-friend-receive", {
                    count: intimate?.receiveList?.length || 0,
                }),
                hasData: intimate?.receiveList?.length > 0,
            },
            {
                key: "relationship-out",
                label: t("chat.apply-friend-sent", {
                    count: intimate?.sendList?.length || 0,
                }),
                hasData: intimate?.sendList?.length > 0,
            },
        ];
        // 优先显示有数据的选项
        return items.sort((a, b) => {
            if (a.hasData && !b.hasData) {
                return -1;
            }
            if (!a.hasData && b.hasData) {
                return 1;
            }
            return 0; // 都有数据或都没数据时保持原顺序
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [intimate.receiveList.length, intimate.sendList.length, show]);

    const getStatusDisplay = (item: IntimateItems): ReactNode => {
        const tempRelation = item.relationship as "lovers" | "buddy" | "bosom_friend";
        switch (item.status) {
            case "process": {
                return (
                    <div className="handle-action">
                        {currentTab === "relationship-in" ? (
                            <Fragment>
                                <Button
                                    type="text"
                                    onClick={handleInvited.bind(this, "refused", item)}
                                >
                                    {t("relationship.refused")}
                                </Button>
                                <div
                                    className={`accept-btn ${tempRelation}`}
                                    onClick={handleInvited.bind(this, "accept", item)}
                                >
                                    <RelationshipIcon relationship={tempRelation} />
                                </div>
                            </Fragment>
                        ) : (
                            <Button
                                className="revoke-btn"
                                icon={
                                    <UndoIcon />
                                    // <UndoOutlined
                                    //     rotate={90}
                                    //     onPointerMoveCapture={undefined}
                                    //     onPointerOverCapture={undefined}
                                    // />
                                }
                                type="text"
                                onClick={handleRevoke.bind(this, item)}
                            >
                                {t("chat.revoke")}
                            </Button>
                        )}
                    </div>
                );
            }
            default: {
                return (
                    <div className={`intimate-status status-${item.status}`}>
                        {t("relationship.status-" + item.status)}
                    </div>
                );
            }
        }
    };
    return intimate.receiveList.length > 0 || intimate.sendList.length > 0 ? (
        <div className="relationship-todo">
            <ContentTabsTop handleChangeTab={changeTab} tabItems={tabItems} />
            <List
                dataSource={
                    currentTab === "relationship-in" ? intimate.receiveList : intimate.sendList
                }
                locale={{ emptyText: <ListEmpty modeType="relationship-in" /> }}
                renderItem={item => (
                    <List.Item key={item.id} className={"card-item " + currentTab}>
                        <div className={`intimate-relation ${item.relationship} ${item.status}`}>
                            <Avatar
                                className="relation-ship-avatar"
                                size={38}
                                src={
                                    currentTab === "relationship-in"
                                        ? item.from.avatar
                                        : item.to.avatar
                                }
                            />
                            {getStatusDisplay(item)}
                            <div className="intimate-user-name">
                                {currentTab === "relationship-in"
                                    ? item.from.userName
                                    : item.to.userName}
                            </div>
                            <div className="intimate-invite-desc">
                                <div className="relation-content-desc">
                                    {t(
                                        currentTab === "relationship-in"
                                            ? "relationship.invite-desc"
                                            : "relationship.invite-desc-card-from",
                                    )}
                                    <Tag className={`relation-tag ${item.relationship}`}>
                                        {t(`relationship.${item.relationship}`)}
                                    </Tag>
                                    {t("relationship.relationship")}
                                </div>
                            </div>
                        </div>
                    </List.Item>
                )}
            />
        </div>
    ) : (
        <div className="relationship-todo-empty">
            <ListEmpty modeType="relationship-in" />
        </div>
    );
};
